module.exports = __webpack_public_path__ + "static/media/mobileban1.024d274c.jpg";